import _ from 'lodash';

export const useAssignedUserData = (
  assignedUserData: Record<string, number>,
) => {
  const labels = Object.keys(assignedUserData);
  const chartDatasets = labels.map(label =>
    _.get(assignedUserData, `${label}`, 0),
  );
  const totalAssignedUsers = Object.values(assignedUserData).reduce(
    (sum, value) => sum + value,
    0,
  );

  // Fungsi untuk menghasilkan warna secara acak
  const generateRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // Menghasilkan warna dan pasangan label-warna secara otomatis
  const colors = labels.map(() => generateRandomColor());
  const labelColorPairs = labels.map((label, index) => ({
    label,
    color: colors[index],
  }));

  return {
    assignedUserData: {
      labels,
      datasets: [
        {
          data: chartDatasets,
          backgroundColor: colors,
        },
      ],
    },
    totalAssignedUsers,
    labelColorPairs,
  };
};
